import { useNavigate } from "react-router-dom";
import { ClipboardList, ScanFace } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";

export default function ScreeningHistory() {
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl" data-testid="screening-history-page">
      <PageHeader title="Screening History" subtitle="Your past face scans & screenings" icon={ClipboardList} color="#0EA5E9" />
      <Card className="rounded-3xl p-8 text-center border-border">
        <ScanFace className="h-10 w-10 mx-auto text-muted-foreground" />
        <p className="mt-3 font-semibold">No screenings yet</p>
        <p className="text-sm text-muted-foreground mt-1">Run a Face Health Scan on the mobile app to see results here.</p>
        <Button className="mt-4 rounded-2xl bg-[#0EA5E9]" onClick={() => navigate("/ai-doctor")} data-testid="screening-start">Learn about Face Scan</Button>
      </Card>
    </div>
  );
}
